/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Waffo_DescriptionInputs */

const en_admin_settings_groups_waffo_description = /** @type {(inputs: Admin_Settings_Groups_Waffo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waffo Pancake payment gateway (Merchant of Record)`)
};

/**
* | output |
* | --- |
* | "Waffo Pancake payment gateway (Merchant of Record)" |
*
* @param {Admin_Settings_Groups_Waffo_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_waffo_description = /** @type {((inputs?: Admin_Settings_Groups_Waffo_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Waffo_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_waffo_description(inputs)
});
export { admin_settings_groups_waffo_description as "admin.settings.groups.waffo.description" }